import { ConditionalTooltip } from '@dealstack/frontend/investor/pages/Valuations/ValuationsDrawer/ConditionalTooltip';
import { Avatar } from '@dealstack/frontend/shared/components/Avatar/Avatar';
import { Box, Text } from '@mantine/core';
import { memo } from 'react';
import { ProgrammeContactDrawerPerson } from './ProgrammeContact.types';

interface Props {
	data: ProgrammeContactDrawerPerson;
}

const ProgrammeContactCard = ({ data }: Props) => {
	const hideTooltipUntilTextLength = 30;

	const fullName = `${data.firstName} ${data.lastName}`;
	return (
		<Box
			sx={(theme) => ({
				display: 'flex',
				padding: '1rem',
				justifyContent: 'flex-start',
				alignItems: 'flex-start',
				gap: '0.25rem',
				borderRadius: '0.25rem',
				border: `1px solid ${theme.colors.gray[2]}`,
			})}
		>
			<div>
				<Avatar size="m" children={fullName} />
			</div>
			<div style={{ width: '19rem' }}>
				<ConditionalTooltip
					label={fullName}
					shouldShowTooltip={fullName?.length > hideTooltipUntilTextLength}
				>
					<Text size="B4Light" tt="capitalize">
						{fullName}
					</Text>
				</ConditionalTooltip>
				<ConditionalTooltip
					label={data.mail}
					shouldShowTooltip={data?.mail?.length > hideTooltipUntilTextLength}
				>
					<Text style={{ marginLeft: '0.25rem', marginTop: '0.25rem' }} size="B6Bold">
						{data.mail}
					</Text>
				</ConditionalTooltip>
			</div>
		</Box>
	);
};
const _ProgrammeContactCardExport = memo(ProgrammeContactCard);

export { _ProgrammeContactCardExport as ProgrammeContactCard };
